<template>
    <v-container>
        <v-btn x-small :color="designStatusColor" dark class="ml-n3 pa-1" @click="showDialog">
            {{ localDesignStatus }}
        </v-btn>
        <v-row justify="center">
            <v-dialog
                    persistent
                    v-model="dialog"
                    max-width="290"
                    @keydown.esc="dialog = false"
                    @keydown.enter="toggleDesignStatus"
                    @keydown.space="toggleDesignStatus"
            >
                <v-card>
                    <v-card-title class="headline">시안확인 상태 변경</v-card-title>
                    <v-card-text>
                        상태를 변경하시겠습니까?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >취소</v-btn>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="toggleDesignStatus"
                        >변경</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
    name: 'DesignStatusButton',
    props: {
        orderId: {},
        designStatus: {},
        disable: {}
    },
    data() {
        return {
            localDesignStatus: this.designStatus,
            designStatusColor: '#5E3E06',
            dialog: false
        }
    },
    methods: {
        showDialog(event) {
            if(this.disable == true){
                return false
            }
            event.preventDefault()
            this.dialog = true
        },
        toggleDesignStatus(event) {

            if(this.disable == true){
                return false
            }

            event.preventDefault()
            this.dialog = false

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + store.getters.getAccessToken
                },
                url: store.getters.getApiUrl + '/api/v1/order/toggleDesignStatus/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.designStatus != ''){

                        this.localDesignStatus = response.data.designStatus
                        this.changeButtonColor()

                    }

                })

        },
        changeButtonColor() {

            if(this.disable == true){

                switch(this.localDesignStatus){

                    case '시안등록전':
                        this.designStatusColor = '#5E3E06'
                        this.localDesignStatus = '등록전'
                        break

                    case '시안확인중':
                        this.designStatusColor = '#4AC8FF'
                        this.localDesignStatus = '확인중'
                        break

                    case '시안수정요청':
                        this.designStatusColor = '#FF5F4C'
                        this.localDesignStatus = '시안수정'
                        break

                    case '고객확인완료':
                        this.designStatusColor = '#8BC737'
                        this.localDesignStatus = '고객확인'
                        break

                    case '방산확인완료':
                        this.designStatusColor = '#353535'
                        this.localDesignStatus = '방산확인'
                        break

                    default:
                        this.designStatusColor = '#5E3E06'
                        break

                }

            }else{

                switch(this.localDesignStatus){

                    case '시안등록전':
                        this.designStatusColor = '#5E3E06'
                        break

                    case '시안확인중':
                        this.designStatusColor = '#4AC8FF'
                        break

                    case '시안수정요청':
                        this.designStatusColor = '#FF5F4C'
                        break

                    case '고객확인완료':
                        this.designStatusColor = '#8BC737'
                        break

                    case '방산확인완료':
                        this.designStatusColor = '#353535'
                        break

                    default:
                        this.designStatusColor = '#5E3E06'
                        break

                }

            }



        }
    },
    created(){
        this.changeButtonColor()
    },
    updated: function() {
        this.get
    }
}
</script>